import {SeoError} from './SeoError.js'

export class GetRemoteSeoContentSeoError extends SeoError {
  static create(message) {
    return new GetRemoteSeoContentSeoError(message)
  }

  static createNotFound() {
    return new GetRemoteSeoContentSeoError('Remote SEO content not found')
  }
}
